export enum PromoName { // must be the same as comes from 'getPromos' request
  vps = 'vps',
}

export enum PromoRoutes { // must match the following: { PromoName = PromoRoute }
  'vps' = 'vps',
}

